import React from 'react';
import styled from '@emotion/styled';

const TeaserLabel = styled('div')`
  position: absolute;
  padding: 4px 8px;
  line-height: 1.25;
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  ${props => props.horizontal}: 0;
  ${props => props.vertical}: 4px;
`;

export default class Label extends React.Component {
  render() {
    //let { className, horizontal, vertical } = this.props;

    return <TeaserLabel {...this.props}>
      {this.props.children}
    </TeaserLabel>;
  }
}

Label.defaultProps = {
  horizontal: 'left',
  vertical: 'top'
};